import { render, staticRenderFns } from "./czrz.vue?vue&type=template&id=13c9114b&scoped=true&"
import script from "./czrz.vue?vue&type=script&lang=js&"
export * from "./czrz.vue?vue&type=script&lang=js&"
import style0 from "./czrz.vue?vue&type=style&index=0&id=13c9114b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c9114b",
  null
  
)

export default component.exports